import styled from 'styled-components';

export const Container = styled.div`
  .btn-submit {
    border-radius: 20px;
  }
`;
